"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Text = _interopRequireDefault(require("./Text"));
var _theme = require("../theme");
/**
 * 
 * @param {*} param0 
 */
var Subtitle = function Subtitle(_ref) {
  var title = _ref.title,
    link = _ref.link,
    id = _ref.id,
    testid = _ref.testid;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    id: id || testid,
    medium: true,
    bold: true,
    margin: "20px 0",
    customStyle: {
      flex: 1
    }
  }, title), link && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: link,
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    color: _theme.colors.skyBlue
  }, "See all")));
};
var _default = exports["default"] = Subtitle;